import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../utils/useWindowSize';

const CustomModalMobileButton = (props) => {
    const { t } = useTranslation();
    const windowWidth = useWindowSize();
    const isMobile = windowWidth <= 542;
    
	return (
        <button disabled={props?.loading} type="button" className="custom-close" id="closeButton" onClick={() => props.onShowHide()}>
            {!isMobile && t('common.close')} <FontAwesomeIcon icon={faXmark}/>
        </button>
	);
};

export default CustomModalMobileButton;
